import React from 'react';
import { products } from '../data/content';
export function Solution() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-146" data-mp="1ekcflhlc8j3c">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-147" data-mp="1ejswhxjybonq">
        <header className="mx-auto max-w-narrow text-center" data-id="element-148" data-mp="10s4nw48wvibi">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-amber-700" data-id="element-149" data-mp="15saintah9kxt">
            La Soluzione
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-night md:text-5xl" data-id="element-150" data-mp="qu8djenssreg">
            Protocollo Settembre Giallo™
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-600 md:text-xl" data-id="element-151" data-mp="hv3gydvsr84x">
            Un sistema integrato di intervento professionale che funziona dal primo minuto.
          </p>
        </header>

        <div className="mt-14 space-y-14 md:mt-16 md:space-y-20" data-id="element-152" data-mp="2c82ywdnngefd">
          {products.map((product, index) => <article key={product.title} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-153" data-mp="2h64lv9o74xw4" data-mpi={index}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-154" data-mp="2z57fq49pnyk">
                <p className="inline-flex items-center gap-2 rounded-full bg-night px-4 py-1.5 font-display text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-amber-400" data-id="element-155" data-mp="2ywtrw0bmemb">
                  {product.eyebrow}
                </p>
                <h3 className="mt-5 font-display text-2xl font-extrabold leading-tight tracking-tight text-night md:text-4xl" data-id="element-156" data-mp="3k7aa3emok0ps">
                  <span className="mr-2" aria-hidden="true" data-id="element-157" data-mp="3g6gmkmd5gnxf">
                    {product.emoji}
                  </span>
                  {product.title}
                </h3>
                <p className="mt-4 font-display text-lg font-bold leading-snug text-gray-700 md:text-xl" data-id="element-158" data-mp="3p6mxc0hgr9sw">
                  {product.lead}
                </p>
                <p className="mt-4 text-lg leading-relaxed text-gray-600" data-id="element-159" data-mp="19deawtuzsoj3">{product.body}</p>
              </div>

              <div className={`space-y-5 ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-160" data-mp="14i8s43wvzpz8">
                {product.images.map(image => <img key={image.src} src={image.src} alt={image.alt} className="w-full rounded-3xl shadow-lift" width={1200} height={1200} data-id="element-161" data-mp="1ghw627xkrmup" />)}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}